import { take, call, put } from 'redux-saga/effects';
import { root as actionTypes } from '$constants/action-types';
import * as actions from '$actions/root';
import axios from 'axios';
import { getStore } from '../store';
import { serializeParams } from '../lib/normalize';

const axiosSuccess = cb => {
  getStore().dispatch(actions.request());
  return cb;
};

const axiosError = errors => {
  getStore().dispatch(actions.response());
  return Promise.reject(errors);
};

axios.interceptors.request.use(config => {
  getStore().dispatch(actions.request());
  return config;
}, axiosError);

axios.interceptors.response.use(response => {
  getStore().dispatch(actions.response());
  return response;
}, axiosError);

axios.defaults.paramsSerializer = (params) => {
  return serializeParams(params);
}

function* watchNotifications() {
  while(true) {
    const { type, errors, info } = yield take('*');

    if (type.endsWith('_FAILURE') && errors && errors.base) {
      const message = errors.base.join(', ');
      yield put(actions.showNotification(message, 'error'));
    } else if (type.endsWith('_SUCCESS') && info) {
      yield put(actions.showNotification(info, 'success'));
    }
  }
}

export function* requirePassword() {
  yield put(actions.requirePassword());
  const action = yield take(actionTypes.SUBMIT_PASSWORD);
  return action.password;
}

export function* alert(...args) {
  yield put(actions.showAlert(...args));
}

export const watchers = [
  watchNotifications
];



// WEBPACK FOOTER //
// ./src/sagas/root.js